import { request } from '../utils/request'
import { stringify } from '../utils/index'

export default {
  recycletagassign: (option) => request('v1/tag/recycletagassign' + stringify(option), option), //  回收标签分配

  getnotusedtags: (option) => request('v1/tag/getnotusedtags', option), //  查询未使用标签列表
  scraptags: (option) => request('v1/tag/scraptags', option), //  报废标签
  gettagscrappeds: (option) => request('v1/tag/gettagscrappeds', option), //   查询报废标签列表

  getappraisalrooms: (option) => request('v1/appraisalroom/getappraisalrooms', option), // 查询鉴定中心列表
  getappraisalroom: (option) => request('v1/appraisalroom/getappraisalroom' + stringify(option), option), // 查询鉴定中心
  addappraisalroom: (option) => request('v1/appraisalroom/addappraisalroom', option), // 新增鉴定中心
  updateappraisalroom: (option) => request('v1/appraisalroom/updateappraisalroom', option), // 修改鉴定中心
  deleteappraisalroom: (option) => request('v1/appraisalroom/deleteappraisalroom' + stringify(option), option), // 删除鉴定中心

  getroomtagassigns: (option) => request('v1/tag/getroomtagassigns', option), // 鉴定中心维度标签下发情况

  gettagsegments: (option) => request('v1/tag/gettagsegments', option), // 查询标签生产列表
  deletetagsegment: (option) => request('v1/tag/deletetagsegment' + stringify(option), option), // 删除标签生产列表
  gettagassigns: (option) => request('v1/tag/gettagassigns', option), // 查询标签分配列表
  gettaguseinfos: (option) => request('v1/tag/gettaguseinfos', option), // 查询标签使用情况
  deletetagassign: (option) => request('v1/tag/deletetagassign' + stringify(option), option), // 删除标签分配项
  addtagsegment: (option) => request('v1/tag/addtagsegment', option), // 生产标签
  assigntagsegment: (option) => request('v1/tag/assigntagsegment', option), // 分配标签
  getusedtags: (option) => request('v1/tag/getusedtags', option) // 查询标签使用列表
}
